import { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import './HeroBanner.css'

interface HeroBannerProps {
  nameId: string
  children?: ReactNode
}

export default function HeroBanner({ nameId, children }: HeroBannerProps) {
  return (
    <section
      id="hero-banner"
      style={{ backgroundImage: `url(/images/hero-banner/${nameId}.jpg)` }}
    >
      <div className="wrapper">
        <h1>
          <FormattedMessage id={`${nameId}.title`} />
        </h1>
        {children}
      </div>
    </section>
  )
}
